var _regeneratorRuntime = require("/vercel/workpath0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Web3 = require("web3");

var TruffleContract = require("@truffle/contract");

var SuperfluidABI = require("../build/abi");

var getConfig = require("./getConfig");

function Framework(_ref) {
  var _this = this;

  var web3Provider = _ref.web3Provider,
      isTruffle = _ref.isTruffle,
      version = _ref.version,
      chainId = _ref.chainId;
  var contractNames = Object.keys(SuperfluidABI);
  this.chainId = chainId;
  this.version = version || "test"; // load contracts

  this.contracts = {};

  if (!isTruffle) {
    if (!web3Provider) throw new Error("web3Provider is required"); // load contracts from ABI

    contractNames.forEach(function (i) {
      var c = _this.contracts[i] = TruffleContract({
        contractName: i,
        abi: SuperfluidABI[i]
      });
      c.setProvider(web3Provider);
    });
    this.web3 = new Web3(web3Provider);
  } else {
    // load contracts from truffle artifacts
    contractNames.forEach(function (i) {
      _this.contracts[i] = global.artifacts.require(i);
    }); // assuming web3 is available when truffle artifacts available

    this.web3 = global.web3;
  }
}

Framework.prototype.initialize = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var chainId, config, superfluidAddress, cfaAddress, idaAddress;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = this.chainId;

          if (_context.t0) {
            _context.next = 5;
            break;
          }

          _context.next = 4;
          return this.web3.eth.net.getId();

        case 4:
          _context.t0 = _context.sent;

        case 5:
          chainId = _context.t0;
          // TODO use eth.getChainId;
          console.log("chainId", chainId);
          config = getConfig(chainId);
          console.debug("Resolver at", config.resolverAddress);
          _context.next = 11;
          return this.contracts.IResolver.at(config.resolverAddress);

        case 11:
          this.resolver = _context.sent;
          console.debug("Resolving contracts with version", this.version);
          _context.next = 15;
          return this.resolver.get.call("Superfluid.".concat(this.version));

        case 15:
          superfluidAddress = _context.sent;
          _context.next = 18;
          return this.resolver.get.call("ConstantFlowAgreementV1.".concat(this.version));

        case 18:
          cfaAddress = _context.sent;
          _context.next = 21;
          return this.resolver.get.call("InstantDistributionAgreementV1.".concat(this.version));

        case 21:
          idaAddress = _context.sent;
          console.debug("Superfluid", superfluidAddress);
          console.debug("ConstantFlowAgreementV1", cfaAddress);
          console.debug("InstantDistributionAgreementV1", idaAddress);
          _context.next = 27;
          return this.contracts.ISuperfluid.at(superfluidAddress);

        case 27:
          this.host = _context.sent;
          _context.next = 30;
          return this.contracts.IConstantFlowAgreementV1.at(cfaAddress);

        case 30:
          _context.t1 = _context.sent;
          _context.next = 33;
          return this.contracts.IInstantDistributionAgreementV1.at(idaAddress);

        case 33:
          _context.t2 = _context.sent;
          this.agreements = {
            cfa: _context.t1,
            ida: _context.t2
          };

        case 35:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
}));

Framework.prototype.getERC20Wrapper = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tokenInfo) {
    var tokenInfoSymbol;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return tokenInfo.symbol.call();

          case 2:
            tokenInfoSymbol = _context2.sent;
            _context2.next = 5;
            return this.host.getERC20Wrapper.call(tokenInfo.address, "".concat(tokenInfoSymbol, "x"));

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

Framework.prototype.createERC20Wrapper = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tokenInfo) {
    var tokenInfoName, tokenInfoSymbol, tokenInfoDecimals;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return tokenInfo.name.call();

          case 2:
            tokenInfoName = _context3.sent;
            _context3.next = 5;
            return tokenInfo.symbol.call();

          case 5:
            tokenInfoSymbol = _context3.sent;
            _context3.next = 8;
            return tokenInfo.decimals.call();

          case 8:
            tokenInfoDecimals = _context3.sent;
            _context3.next = 11;
            return this.host.createERC20Wrapper(tokenInfo.address, tokenInfoDecimals, "Super ".concat(tokenInfoName), "".concat(tokenInfoSymbol, "x"));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}();

module.exports = Framework;